<template>
    <b-container fluid style="margin-top: 60px">
        <h1>
            {{ $t('nav_uitpekelen', { ns: 'nav' }) }}
        </h1>
        <b-row @click="handleLogOut()">
            <b-col sm="12" md="6">
                <b-alert v-model="showAlert" :variant="alertVariant">
                    <h3>{{ alertTextTimer }}</h3>
                </b-alert>
            </b-col>
            <b-col sm="12" md="6" class="text-md-right">
                <b-alert v-model="showAlert" :variant="alertVariant">
                    <h3>{{ alertTextPlace }}</h3>
                </b-alert>
            </b-col>
            <p id="demo"></p>
        </b-row>

        <b-row>
            <b-col sm="12">
                <b-table
                    :items="displayList"
                    :fields="visibleFields"
                    stacked="md"
                    show-empty
                    :empty-text="$t('com_geen_data', { ns: 'common' })"
                    small
                    striped
                >
                </b-table>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import DateHelper from '../../models/DateHelper';
import { loadItem } from '../../models/DataHelper';
import { silentRenewToken } from '../account/security';

export default {
    name: 'OutbrineDashboard',
    data: function () {
        return {
            interval: null,
            tijd: 1000 * 60 * 10, //iedere 10 minuut
            pekelLijst: null,
            eersteUitPekel: null,
            countDownDate: null,
            showAlert: false,
            alertTextTimer: '',
            alertTextPlace: '',
            alertVariant: 'info'
        };
    },
    components: {},
    computed: {
        visibleFields() {
            const fieldsInit = [
                { key: 'id', label: 'Id', sortable: false, visible: false },
                {
                    key: 'productieDatum',
                    label: this.$t('com_datum', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                { key: 'bakno', label: '#', sortable: true, visible: true },
                {
                    key: 'bakgroepInternID',
                    label: 'BG#',
                    sortable: true,
                    visible: true
                },
                {
                    key: 'kaasnaam',
                    label: this.$t('com_kaassoort', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'aantal',
                    label: this.$t('com_number', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'vorm',
                    label: this.$t('prod_vorm', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'inpekeltijd',
                    label: this.$t('prod_inpekel', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'kooilaag',
                    label: this.$t('prod_kooi', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'urenInPekel',
                    label: this.$t('prod_uurinpekel', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'uitpekel',
                    label: this.$t('prod_uitpekel', { ns: 'production' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        displayList() {
            return this.pekelLijst ? this.pekelLijst : [];
        }
    },
    methods: {
        async loadData() {
            const o = DateHelper.determineVanTotUTC(null, -14, 14);
            const selectionData = {
                from: o.van,
                until: o.tot
            };
            // als gebruiker een token heeft dan anoniem gebruiken anders gewoon
            let lijst = [];
            if (localStorage.getItem('lrt-token')) {
                console.log('Loading outbrine info anonymous');
                // zorg dat het token nog geldig is, indien nodig stilzwijgend vernieuwen
                await silentRenewToken();
                lijst = await loadItem(
                    'outbrine/loadOutbrineInfoAnonymous',
                    selectionData,
                    this.$t
                );
            } else {
                console.log('Loading outbrine voor test');
                // zorg dat het token nog geldig is, indien nodig stilzwijgend vernieuwen
                await silentRenewToken();
                lijst = await loadItem(
                    'outbrine/loadOutbrineInfoOverPeriod',
                    selectionData,
                    this.$t
                );
            }
            const filtered = lijst.filter(
                (item) =>
                    item.uitpekeltijd == undefined &&
                    item.inpekeltijd != undefined
            );
            this.pekelLijst = filtered.sort(
                (a, b) => a.uitpekeltijd - b.uitpekeltijd
            );
            this.eersteUitPekel =
                this.pekelLijst.length > 0 ? this.pekelLijst[0] : null;
            const showTIJD = this.eersteUitPekel != null;
            if (showTIJD) {
                this.countDownDate = DateHelper.convertedToDateTimeJS(
                    this.eersteUitPekel.uitpekeltijdplanOri
                ).getTime();
                setInterval(this.countDown, 1000);
            }
            this.showAlert = showTIJD;
        },
        countDown() {
            const now = new Date().getTime();

            // Find the distance between now and the count down date
            const distance = this.countDownDate - now;
            // Time calculations for days, hours, minutes and seconds
            const absdistance = Math.abs(distance);
            const days = Math.floor(absdistance / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
                (absdistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor(
                (absdistance % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor((absdistance % (1000 * 60)) / 1000);

            this.alertVariant = distance < 0 ? 'danger' : 'success';
            const prefix = distance < 0 ? '- ' : '';
            this.alertTextTimer =
                prefix +
                days +
                'd ' +
                hours +
                'h ' +
                minutes +
                'm ' +
                seconds +
                's ';
            this.alertTextPlace =
                this.eersteUitPekel != null
                    ? this.eersteUitPekel.kooilaag
                    : this.$t('com_onbekend', { ns: 'common' });
        },
        handleLogOut() {
            this.$store.commit('account/setJWTToken', null);
            const manager = this.$store.getters['account/getLogInManager'];
            if (manager != undefined) manager.signOut();
            loadItem('account/loadUserManager', null);
            localStorage.removeItem('lrt-token');
        }
    },
    mounted() {
        this.loadData();
    },
    created() {
        setInterval(async () => {
            await this.loadData();
        }, this.tijd);
    }
};
</script>

<style scoped></style>
